import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulse, Heart, Coins, Sparkles } from 'lucide-react';
const areas = [{
  title: 'SALUD',
  icon: HeartPulse,
  desc: 'Ansiedad, insomnio y agotamiento físico constante.'
}, {
  title: 'AMOR',
  icon: Heart,
  desc: 'Relaciones tóxicas y pérdida de amor propio.'
}, {
  title: 'DINERO',
  icon: Coins,
  desc: 'Falta de enfoque en tus metas y estancamiento profesional.'
}, {
  title: 'ESPIRITUALIDAD',
  icon: Sparkles,
  desc: 'Desconexión de tu propósito y vacío interior.'
}];
export function FourAreas() {
  return <section className="py-24 bg-teal-950 text-cream px-6" data-id="element-94">
      <div className="max-w-6xl mx-auto" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-96">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif mb-6" data-id="element-97">
            Las 4 áreas que el apego está{' '}
            <span className="italic text-gold" data-id="element-98">drenando ahora mismo:</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-99">
          {areas.map((area, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-teal-900 p-8 rounded-2xl border border-cream/5 hover:bg-teal-800 transition-colors" data-id="element-100">
              <div className="w-14 h-14 rounded-full bg-gold/20 flex items-center justify-center mb-6 text-gold" data-id="element-101">
                <area.icon className="w-7 h-7" data-id="element-102" />
              </div>
              <h3 className="text-xl font-bold tracking-wider mb-3" data-id="element-103">
                {area.title}
              </h3>
              <p className="text-cream/70 leading-relaxed" data-id="element-104">{area.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}